import {
  Box,
  Column,
  Columns,
  Heading,
  Inline,
  Stack,
} from 'braid-design-system';
import type { FC, ReactNode } from 'react';

import { Display } from 'src/libs/Display';

export const JobSectionLayout: FC<{
  heading: JSX.Element;
  details: JSX.Element;
  jobAction: {
    desktop: JSX.Element | null;
    mobile: JSX.Element | null;
  };
  alert: ReactNode;
  modals: ReactNode;
  freemiumButton: JSX.Element | null;
}> = ({ heading, details, jobAction, alert, modals, freemiumButton }) => (
  <div data-testid="job-information" data-intercom-target="job-information">
    <Box data-testid="title">
      <Stack space="none">
        <Box paddingY="xxsmall">
          <Columns space="small" collapseBelow="tablet">
            <Column>
              <Stack space="small">
                <Box paddingTop="large">
                  <Heading level="3">{heading}</Heading>
                </Box>
                <Box paddingTop="xxsmall">{details}</Box>
              </Stack>
            </Column>

            <Column width="content">
              <Inline space="none" alignY="center">
                <Box
                  paddingTop={['xxsmall', 'large']}
                  paddingRight={freemiumButton ? 'small' : 'none'}
                >
                  <Display tablet desktop>
                    {jobAction.desktop}
                  </Display>
                  <Display mobile>{jobAction.mobile}</Display>
                </Box>

                <Box paddingTop={['xxsmall', 'large']}>{freemiumButton}</Box>
              </Inline>
            </Column>
          </Columns>
          {alert}
          {modals}
        </Box>
      </Stack>
    </Box>
  </div>
);
